<template>
  <div class="app">
    <carousel firstslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2FFord--%2B-Udo-067.png?alt=media&token=8a299f8f-dd59-437b-aaa5-31116f97b291" sencondslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2FFord--%2B-Udo-067.png?alt=media&token=8a299f8f-dd59-437b-aaa5-31116f97b291" thirdslide="https://firebasestorage.googleapis.com/v0/b/mediathek-7f332.appspot.com/o/autotransport%2Fheader%2FFord--%2B-Udo-067.png?alt=media&token=8a299f8f-dd59-437b-aaa5-31116f97b291" />
    <contact title="Transportauftrag"/>
  </div>
</template>
<style lang="scss" scoped>
.transparent {
  display: none;
}
</style>
<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbJumbotron,
  mdbNavItem,
  mdbListGroup,
  mdbEdgeHeader
} from "mdbvue";
import contact from "@/components/contact";
import carousel from "@/components/carousel";

export default {
  name: "transportauftrag",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbJumbotron,
    mdbNavItem,
    mdbListGroup,
    mdbEdgeHeader,
    contact,
    carousel
  }
};
</script>